// TODO Move to a library so that both seeker-app and entry-page share same logic

import { type SearchHighlights } from '@smg-real-estate/geo-libs';

import type { HighlightPart } from './types';

export const renderPlainTextPart = (text: string): HighlightPart[] => [
  { text, isHighlighted: false },
];

export function renderHighlightParts(
  highlights: SearchHighlights,
  name: string,
): HighlightPart[] | undefined {
  const highlightRanges = highlights[name];
  if (!highlightRanges || highlightRanges.length === 0) {
    return;
  }

  const parts: HighlightPart[] = [];
  let i = 0;

  for (const { from, to } of highlightRanges) {
    // skip invalid ranges
    if (isInvalidRange(name, from, to)) {
      continue;
    }
    appendPart(parts, name.substring(i, from), false);
    appendPart(parts, name.substring(from, to), true);
    i = to;
  }

  appendPart(parts, name.substring(i), false);

  return parts;
}

const appendPart = (parts: HighlightPart[], text: string, isHighlighted: boolean): void => {
  if (text) {
    parts.push({ text, isHighlighted });
  }
};

const isInvalidRange = (term: string, from: number, to: number): boolean =>
  from < 0 || from > term.length || to < 0 || to > term.length || from >= to;
